import React from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://7vtxaf-x1.myshopify.com/cart/45821756342458:1';
export function StickyMobileCTA() {
  return <motion.div initial={{
    y: 100
  }} animate={{
    y: 0
  }} className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t-2 border-gray-200 p-4 shadow-2xl" data-id="element-143">
      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg py-4 rounded-lg shadow-lg transition-all duration-300" data-id="element-144">
        COMPRAR AHORA
      </a>
    </motion.div>;
}